import { useEffect } from 'react';
import EcoNavPage from 'eco-design/sections/eco-nav-page';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

export default function Comp() {
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct.NavPage');
    const itemsA = [
        {
            title: t('item1'),
            href: '#Screen1-content',
        },
        {
            title: t('item2'),
            href: '#Screen2',
        },
        {
            title: t('item3'),
            href: '#Screen3',
        },
    ];

    const itemsA_JP = [
        {
            title: t('item1'),
            href: '#Screen1-content',
        },
        {
            title: t('item3'),
            href: '#Screen3',
        },
        {
            title: t('item2'),
            href: '#Screen2',
        },
    ];

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const callback = () => {
            const screen1 = document.getElementById('Screen1');
            if (screen1) {
                const screen1Top = screen1.getBoundingClientRect().top;
                if (screen1Top <= 0) {
                    document.getElementById('NavPage')?.classList.add('active');
                } else {
                    document.getElementById('NavPage')?.classList.remove('active');
                }
            }
        };
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, []);
    return (
        <div className={`${styles.comp} GtmModuleData-section`} id="NavPage" data-section-id={'NavPage'}>
            <EcoNavPage items={locale === 'jp' ? itemsA_JP : itemsA} />
        </div>
    );
}
